<template>

    <button @click="openCart" type="button" class="flex flex-shrink-1 xl:w-auto h-auto justify-center items-center group transition-all">
        <span class="flex gap-x-2 xl:gap-x-0 xl:border-l border-customGray-text xl:pl-5">
            <span class="flex-shrink-0 inline-flex items-center xl:hidden">
                <img alt="cart" src="/images/svg/carrello.svg" class="h-5.5 w-auto"/>
            </span>
            <span class="inline-flex items-center mx-auto relative">
                <span class="relative aspect-square w-6.5 h-6.5 md:w-7 md:h-7 xl:w-5.5 xl:h-5.5 border border-customGray-text rounded-full flex items-center justify-center">
                    <span class="block mx-auto relative text-xs xl:text-xxs text-customGray-text !leading-none pt-[.1rem]" v-text="counter"></span>
                </span>
            </span>
        </span>

    </button>

</template>

<style lang="scss" scoped>
</style>

<script>

    export default {
        props: ['initCounter', 'cartLink', 'theme'],
        data() {
            return {
                counter: 0
            }
        },
        mounted() {
            this.counter = parseInt(this.initCounter);
            this.$eventHub.$on('cart.added', payload => {
                this.counter = parseInt(payload.count);
            });

            this.$eventHub.$on('cart.updated.simpleQty', payload => {
                this.counter = payload;
            });
        },
        beforeDestroy() {
            this.$eventHub.$off('cart.added');
            this.$eventHub.$off('cart.updated.simpleQty');
        },
        methods: {
            openCart() {
                if(this.counter == 0) {
                    window.location.href = this.$root.langRoute('/shop')
                    return
                }
                if(window.innerWidth < 1280) {
                    window.location.href = this.$root.langRoute('/carrello');
                }else{
                    this.$eventHub.$emit('cart.show', {});
                }
            },
        }
    }

</script>
